import { Injectable } from "@angular/core";
import { BaseService, ServiceResponse } from "../base.service";
import { environment } from "src/environments/environment";
import { lastValueFrom } from "rxjs";
import { ArqueoCaja } from "src/app/models/cobranza/arqueo-caja.model";

@Injectable({
    providedIn: 'root'
})
export class ArqueoCajaService extends BaseService {
    
    override recordName = 'arqueos_caja';

    override url = `${ environment.host }/arqueo-caja`;
    
    override codigoRegistro = ArqueoCaja.CODIGO_REGISTRO;

    async cerrarArqueo( body?: Record<string, any>) {      
        let url = `${this.url}/cerrar-arqueo`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async abrirArqueo( body?: Record<string, any>) {      
        let url = `${this.url}/abrir-arqueo`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    async consultarArqueo( filtros?: Record<string, any>): Promise<ServiceResponse> {      
        let url = `${this.url}/consultar-arqueo`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  filtros , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

}